import { FirebaseAuthService } from "../auth/services/firebase-auth.service";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { map } from "rxjs/operators";
import { Store } from "@ngrx/store";

@Injectable()
export class ClientSelectedGuard implements CanActivate {
  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    private store: Store<any>
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const queryParams = next.queryParams;
    const url = state.url;
    const client_data = JSON.parse(localStorage.getItem("client"));
    if (client_data) {
      return true;
    } else {
      const reportTypePath = url.includes("3pd-reports")
        ? "3pd-reports"
        : url.includes("payout-reporting")
        ? "payout-reporting"
        : url.includes("trend-analysis")
        ? "trend-analysis"
        : url.includes("error-charge-manager")
        ? "error-charge-manager"
        : null;
      if (reportTypePath && queryParams.shared) {
        const segments = url.split("/");
        const reportid = segments[3].split("?")[0];
        localStorage.setItem("redirectTo", reportTypePath);
        localStorage.setItem("reportId", reportid);
        localStorage.setItem("shared", queryParams.shared);
        localStorage.setItem("downloadOnLoad", queryParams.downloadOnLoad);
      }
      this.router.navigate(["client-selection"]);
    }
  }
}
